import React from "react";
import OfferList from "../../../components/AdminComponents/offers";

const Offers = () => {
  return (
    <div className="flex h-full">
      <OfferList />
    </div>
  );
};

export default Offers;
